document.addEventListener('DOMContentLoaded', function() {
  console.log('Popup + VAT + Shipping Loaded');

  const popup = document.getElementById('tax-popup');
  const shippingPopup = document.getElementById('shipping-popup');
  const checkoutDrawerBtn = document.getElementById('custom-checkout-drawer');
  const checkoutPageBtn = document.getElementById('custom-checkout-page');
  const confirmButton = document.getElementById('confirmButton');
  const confirmButtonnon = document.getElementById('confirmButtonnon');
  const citySearchInput = document.getElementById('city-search');
  const cityList = document.getElementById('city-list');
  const cityItems = document.querySelectorAll('.city-item');
  let selectedCity = '';

  // === VAT FIX FUNCTION ===
  async function fixCartVariantsVAT(selectedOption) {
    let targetOption = null;
    if (selectedOption === 'nontex') targetOption = "ללא מע\"מ";
    else if (selectedOption === 'tax') targetOption = "לפני מע\"מ";
    else return alert("No VAT selection provided.");

    const cartData = await fetch('/cart.js').then(res => res.json());
    const updates = {};
    const additions = [];

    for (const item of cartData.items) {
      if (!item.variant_options.includes(targetOption)) {
        const productData = await fetch(`/products/${item.handle}.js`).then(res => res.json());
        const correctVariant = productData.variants.find(v => v.options.includes(targetOption));
        if (correctVariant) {
          updates[item.variant_id] = 0;
          additions.push({ id: correctVariant.id, quantity: item.quantity });
        }
      }
    }

    if (Object.keys(updates).length > 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ updates }),
      });
    }

    if (additions.length > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ items: additions }),
      });
    }
  }

  // === HANDLE VAT SELECTION ===
  async function handleSelection(option) {
    sessionStorage.setItem('selected_option', option);
    sessionStorage.setItem('popup_shown', 'true');
    updateDropdown(option);

    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;
    if (option === 'tax') {
      searchParams.set('tax', 'true');
      searchParams.delete('nontex');
    } else if (option === 'nontex') {
      searchParams.set('nontex', 'true');
      searchParams.delete('tax');
    }
    window.history.replaceState({}, '', currentUrl.toString());

    popup.style.display = 'none';
    document.body.classList.remove('tax-popup');

    try {
      await fixCartVariantsVAT(option);
    } catch (error) {
      alert('אירעה שגיאה בעדכון העגלה. בדוק את הקונסול לפרטים נוספים.');
      console.error(error);
    }

    window.location.href = '/checkout';
  }

  // === UPDATE DROPDOWN ===
  function updateDropdown(option) {
    let dropdown = document.querySelector('select[name="options[Tax]"]');
    if (dropdown) {
      dropdown.value = option === 'tax' ? 'לפני מע"מ' : 'ללא מע"מ';
      dropdown.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // === SHOW MAIN POPUP ===
  function showPopup() {
    if (!popup) return;
    popup.style.display = 'flex';
    popup.classList.add('model-open');
    document.body.classList.add('tax-popup');

    popup.querySelector('.close-btn')?.addEventListener('click', () => {
      popup.style.display = 'none';
      document.body.classList.remove('tax-popup');
    });
  }

  // === SHOW SHIPPING POPUP ===
  function showShippingPopup() {
    if (!shippingPopup) return;
    shippingPopup.style.display = 'flex';
    shippingPopup.classList.add('model-open');
    document.body.classList.add('shipping-popup');

    // Close shipping popup
    shippingPopup.querySelector('.close-btn')?.addEventListener('click', closeShippingPopup);

    // === Add product to cart when clicking "Shipment" ===
    const shipmentBtn = shippingPopup.querySelector('#shipment-btn');
    if (shipmentBtn) {
      shipmentBtn.addEventListener('click', async () => {
        const productId = document.getElementById('shipping-product-id')?.value;
        if (!productId) {
          console.error("No product ID found for shipping popup.");
          return;
        }

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: productId, quantity: 1 }]
            }),
          });

          if (res.ok) {
            console.log('Shipping product added to cart');
            closeShippingPopup();
            await handleSelection('nontex'); // Proceed to checkout
          } else {
            console.error('Failed to add shipping product:', res.statusText);
          }
        } catch (error) {
          console.error('Error adding shipping product:', error);
        }
      });
    }

    // Pickup button → just close popup & continue
    const pickBtn = shippingPopup.querySelector('#pick-btn');
    if (pickBtn) {
      pickBtn.addEventListener('click', async () => {
        closeShippingPopup();
        await handleSelection('nontex');
      });
    }
  }

  function closeShippingPopup() {
    shippingPopup.style.display = 'none';
    document.body.classList.remove('shipping-popup');
  }

  // === CITY SELECTION ===
  function checkCitySelection(cityName) {
    selectedCity = cityName;
    confirmButton.disabled = false;
    confirmButtonnon.disabled = false;

    if (cityName === "אילת" || cityName === "Eilat" || cityName === "Elat") {
      confirmButton.disabled = true;
      confirmButtonnon.disabled = false;
    } else {
      confirmButton.disabled = false;
      confirmButtonnon.disabled = true;
    }
  }

  if (citySearchInput && cityItems.length > 0) {
    citySearchInput.addEventListener('input', function() {
      const searchValue = this.value.toLowerCase();
      let matchFound = false;

      cityItems.forEach(item => {
        const cityName = item.textContent.toLowerCase();
        if (cityName.includes(searchValue)) {
          item.style.display = "block";
          matchFound = true;
        } else {
          item.style.display = "none";
        }
      });

      cityList.style.display = matchFound && searchValue !== "" ? "block" : "none";

      if (this.value === "") {
        confirmButton.disabled = true;
        confirmButtonnon.disabled = true;
      }
    });

    document.addEventListener('click', function(event) {
      if (!event.target.closest('.selectcity-dropdown')) cityList.style.display = "none";
    });

    cityItems.forEach(item => {
      item.addEventListener('click', function() {
        const cityName = this.textContent;
        citySearchInput.value = cityName;
        cityList.style.display = "none";
        checkCitySelection(cityName);
      });
    });
  }

  // === MAIN BUTTONS HANDLING ===
  if (confirmButton) {
    confirmButton.addEventListener('click', () => handleSelection('tax'));
  }

  if (confirmButtonnon) {
    confirmButtonnon.addEventListener('click', () => {
      if (selectedCity === "אילת" || selectedCity === "Eilat" || selectedCity === "Elat") {
        showShippingPopup();
      } else {
        handleSelection('nontex');
      }
    });
  }

  // === GLOBAL CHECKOUT BUTTON ===
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('#custom-checkout-drawer, #custom-checkout-page');
    if (!btn) return;

    e.preventDefault();
    const selectedOption = sessionStorage.getItem('selected_option');
    if (selectedOption) {
      window.location.href = '/checkout';
      return;
    }

    showPopup();
  });
});
